import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { getDataByPathId } from '@/common/LandingDataContent';
import _ from 'lodash';
import { mainLabelMap } from '@/common/mainLabel';

const stepIcons = ['/images/landing/judge-1.webp', '/images/landing/judge-2.webp', '/images/landing/judge-3.webp'];

const HairstylesCreatedContent = ({ data }: { data?: { pathId?: string; label?: string } }) => {
  const pathId = data?.pathId;
  const label = data?.label;
  const labelContent = getDataByPathId(pathId || '');
  const labelShow = _.upperFirst(label);
  const labelData = labelContent.label_data[labelShow];
  return (
    <div className={styles.content}>
      <h2 className={styles.h2}>
        {label === 'all' ? (
          <span>{labelContent.create_content.title.all}</span>
        ) : (
          (() => {
            const tip = labelContent.create_content.title.other;
            const parts = tip.split('***');
            return (
              <span>
                {parts[0]}
                <span className={styles.highlight}>{labelShow}</span>
                {parts[1]}
              </span>
            );
          })()
        )}
      </h2>
      <h3 className={styles.h3}>{labelContent.create_content.sub_title}</h3>
      <div className={styles.container}>
        {stepIcons.map((item, idx) => (
          <div className={styles.stepCard} key={idx}>
            <div className={styles.cardHeader}>
              <div className={styles.stepTitle}>{`Step ${idx + 1}`}</div>
              <Image src={item} alt="icon" width={126} height={126} className={styles.icon} />
            </div>
            <h3>
              <div className={styles.desc}>{labelData.steps[`Step ${idx + 1}`]}</div>
            </h3>
          </div>
        ))}
      </div>
      <div className={styles.bottomBtn}>
        {(() => {
          const callbackContent = labelContent.callback.normal;
          const parts = callbackContent.split('***');
          return (
            <span>
              {parts[0]}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const anchor = document.getElementById('main-content-anchor');
                  if (anchor) {
                    anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                {labelContent.callback.link}
              </a>
              {parts[1]}
            </span>
          );
        })()}
      </div>
      <div className={styles.tipsSection}>
        <h2 className={styles.tipsTitle}>
          <span>
            {(() => {
              let labelShowTip = '';
              if (label === 'all') {
                labelShowTip = 'All ' + mainLabelMap.get(pathId || '');
              } else {
                labelShowTip = labelShow;
              }
              return (
                <>
                  Styling Tips for <span className={styles.tipsHighlight}>{labelShowTip}</span>
                  <span className={styles.tipsItalic}>{": Do's & Don'ts"}</span>
                </>
              );
            })()}
          </span>
        </h2>
        <h3 style={{ display: 'none' }}>What is recommended</h3>
        <h3 style={{ display: 'none' }}>What should be avoided</h3>
        <div className={styles.tipsCardsWrapper}>
          {(() => {
            const tipsDataArr = [
              { type: 'well', ...labelData.suggest.well },
              { type: 'avoid', ...labelData.suggest.avoid }
            ];
            return tipsDataArr.map((item) => (
              <div className={styles.tipsCard} key={item.type}>
                <div className={styles.tipsCardTitle}>{item.title}</div>
                <div
                  className={styles.tipsCardContent}
                  style={{ background: item.type === 'well' ? '#35603a' : '#6b2d2d' }}
                >
                  {item.tips.map((tip, idx) => (
                    <div key={idx} className={styles.tipsCardContentLine}>
                      {tip}
                    </div>
                  ))}
                </div>
              </div>
            ));
          })()}
        </div>
      </div>
      <div className={styles.fitChartSection}>
        <h2 className={styles.fitChartTitle}>{labelContent.fitChat.title}</h2>
        <div className={styles.fitChartTable}>
          <div className={styles.fitChartRow + ' ' + styles.fitChartHeader}>
            {labelContent.fitChat.header.map((h, idx) => (
              <div className={styles.fitChartCell} key={idx} style={{ justifyContent: idx > 0 ? 'center' : null }}>
                {h}
              </div>
            ))}
          </div>
          {labelContent.fitChat.rows.map((row, i) => (
            <div className={styles.fitChartRow} key={i}>
              <div className={styles.fitChartCell + ' ' + styles.fitChartShape}>{row.shape}</div>
              {row.values.map((v, j) => (
                <div className={styles.fitChartCell} key={j} style={{ justifyContent: 'center' }}>
                  {v}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className={styles.fitChartTips}>
          {labelContent.fitChat.tips.map((tip, idx) => (
            <span className={styles.fitChartTip} key={idx}>
              {tip}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HairstylesCreatedContent;
